import React, { Component } from 'react';
import { SelectAsync } from '../input/select/main';
import { connect } from 'formik';
import { ISelectClassesProps, IFormikProps } from '../../models/components/select-classes';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';
import { UserType } from '../../models/enums/userType';

const T = Translator.create();
const _logger = Log.create('main-tabpanel');
let trigger = false;

export class SelectClasses extends Component<IFormikProps<any>> {
    constructor(props: any) {
        super(props);
    }

    public state = {
        isExamPublished: false,
        isClassesLoaded: false
    };

    handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.props.formik.setFieldValue(name, value);
    };

    selectCallback = () => {
        if (!this.state.isClassesLoaded) this.setState({ isClassesLoaded: true });
    };

    componentDidUpdate(prevProps: Readonly<IFormikProps<any>>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.formik.values.isAllClass !== prevProps.formik.values.isAllClass) {
            if (this.props.formik.values.isAllClass) {
                trigger = true;
            } else {
                trigger = false;
            }
        }
        if (this.props.formik.values.selectedClass !== prevProps.formik.values.selectedClass) {
            trigger = false;
        }

        if (this.props.isUpdate && this.props.publishDatas) {
            if (
                this.props.publishDatas.isPassive === 0 &&
                this.props.publishDatas.activeStatus === 1 &&
                this.state.isExamPublished == false
            ) {
                this.setState({ isExamPublished: true });
            }
        }
        if (!this.state.isClassesLoaded) this.setState({ isClassesLoaded: true });
    }

    public render() {
        let isCreateGeneralActivity: boolean = false;
        if (Common.HasPermission(SecurityContextType.Course, SecurityPermissionType.Activity_Add, this.props.coursePageActivityId)) {
            isCreateGeneralActivity = true;
        }
        if (this.props.formik.values.selectedClass) {
            let selectedClassArray: Array<string> = this.props.formik.values.selectedClass;
            let selectedClassArrayStringify: string = JSON.stringify(selectedClassArray);
            this.props.selectedClassIds(selectedClassArrayStringify);
        }

        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_selectClassTab' ? ' show active' : '')}
                id="select-classes"
                role="tabpanel"
                aria-labelledby="select-class-tab"
            >
                <div className="row">
                    <div className="col-md-6">
                        <div className="radio-tabs tick-radio position-relative">
                            <input
                                type="radio"
                                name={'isCommon'}
                                onChange={this.props.formik.setFieldValue.bind(this, 'isCommon', 0)}
                                value={0}
                                checked={this.props.formik.values.isCommon === 0 ? true : false}
                                id="radio-one"
                                className="form-radio"
                                defaultChecked={this.props.formik.values.isCommon === 0 ? true : false}
                            />
                            <label htmlFor="radio-one" style={{ marginInlineStart: '6px' }}>
                                {T.t('r_branch_activity')}
                            </label>
                        </div>
                    </div>
                    {isCreateGeneralActivity && this.props.userType !== UserType.Teacher && (
                        <div className="col-md-6">
                            <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                <input
                                    type="radio"
                                    name={'isCommon'}
                                    onChange={this.props.formik.setFieldValue.bind(this, 'isCommon', 1)}
                                    value={1}
                                    checked={this.props.formik.values.isCommon === 1 ? true : false}
                                    id="radio-two"
                                    className="form-radio"
                                    defaultChecked={this.props.formik.values.isCommon === 1 ? true : false}
                                />
                                <label htmlFor="radio-two">{T.t('r_general_activity')}</label>
                            </div>
                        </div>
                    )}
                </div>
                <div
                    className="add-branch mt-4 animated fadeInDown"
                    style={{ display: this.props.formik.values.isCommon === 0 ? 'block' : 'none', animationDuration: '0.2s' }}
                >
                    <div className="row">
                        <div className="col-6">
                            <label className="input-label mb-0">
                                {T.t('r_add_branch')}
                                <span className="ml-1" style={{ color: '#dc5050' }}>
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="col-sm-6 tick-radio text-md-right mt-sm-0 mt-3">
                            <div style={{ position: 'absolute', insetInlineEnd: 15 }}>
                                {!this.state.isClassesLoaded ? (
                                    <div className="spinner-border spinner-border-sm text-success" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                ) : (
                                    <>
                                        <input
                                            disabled={this.state.isExamPublished}
                                            type="checkbox"
                                            name="isAllClass"
                                            id="allClass"
                                            onChange={this.handleInputChange}
                                            checked={this.props.formik.values.isAllClass}
                                            className="form-radio"
                                        />
                                        <label style={{ marginInlineStart: 10, width: 'auto', marginTop: 2 }} htmlFor="allClass">
                                            {T.t('r_select_all_branches')}
                                        </label>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="multioptions k-365-input">
                        <SelectAsync
                            isMulti={true}
                            className='k365-select'
                            isSearchable={true}
                            requestType={'post'}
                            parameter={{ CourseId: this.props.coursePageActivityId, SelectedIds: [], Skip: 0, Take: 9999 }}
                            placeHolder={!this.props.formik.values.isAllClass ? T.t('r_select_branch') : T.t('r_all_branches_selected')}
                            url={'api/class/classes'}
                            closeMenuOnScroll={false}
                            closeMenuOnSelect={false}
                            setSelectValue={this.props.isUpdate ? this.props.formik.values.selectedClass : ''}
                            name={'selectedClass'}
                            value={this.props.formik.values.selectedClass}
                            onChange={this.props.formik.handleChange}
                            setFieldValue={this.props.formik.setFieldValue}
                            errors={this.props.formik.errors.selectedClass}
                            touched={this.props.formik.touched.selectedClass}
                            isTouched={this.props.formik.setFieldTouched}
                            isDisabled={this.props.formik.values.isAllClass}
                            isAll={this.props.formik.values.isAllClass}
                            callback={this.selectCallback}
                            type='branch'
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect<ISelectClassesProps, any>(SelectClasses);
